import { FreeLoader } from 'components/atoms/Loader/Loader.component';

const Spinner = () => (
  <FreeLoader className="text-taxes-400 fill-taxes w-10 h-10" />
);

export default Spinner;
